// extracted by mini-css-extract-plugin
export var wrapper = "ArticleConversationBlock-module--wrapper--33WCn";
export var space = "ArticleConversationBlock-module--space--3wkRH";
export var message = "ArticleConversationBlock-module--message--KdYR9";
export var messageRight = "ArticleConversationBlock-module--messageRight--28az0";
export var messageLeft = "ArticleConversationBlock-module--messageLeft--flMdT";